import { LocationSelector } from "@/components/location-selector/location-selector";
import { MarginBottom } from "@/screens/login/login-seller/style";
import { TitleInput } from "@/screens/register/register-buy/style";

const StepBuyerAddress: React.FC = () => {
  return (
    <>
      <TitleInput>Endereço</TitleInput>
      <LocationSelector />
      <MarginBottom />
    </>
  );
}

export default StepBuyerAddress